// One date-range control for every dashboard (D15). Lives in the WorkspaceFrame header slot.
export interface RangeOption<V extends string> {
  value: V;
  label: string;
}

export function DateRange<V extends string>({
  value,
  onChange,
  options,
  label = 'Date range',
}: {
  value: V;
  onChange: (v: V) => void;
  options: readonly RangeOption<V>[];
  label?: string;
}) {
  return (
    <div role="group" aria-label={label} className="fl-segmented">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
